import PERMISSIONS from '@/constants/auth.constants';

export const ADMINISTRATION_TABS = [
  {
    label: 'General',
    path: '/administration',
    value: 0,
    ariaLabel: 'general-tab',
    permissions: 'exempt'
  },
  {
    label: 'Devices',
    path: '/administration/devices',
    value: 1,
    ariaLabel: 'devices-tab',
    permissions: [PERMISSIONS.DEVICES_READ]
  },
  {
    label: 'Cloud Sources',
    path: '/administration/cloud-sources',
    value: 12,
    ariaLabel: 'cloud-sources-tab',
    permissions: [PERMISSIONS.SOURCES_READ]
  },
  {
    label: 'Users',
    path: '/administration/users',
    value: 2,
    ariaLabel: 'users-tab',
    permissions: PERMISSIONS.USERS_READ
  },
  {
    label: 'AI Settings',
    path: '/administration/ai-settings',
    value: 11,
    ariaLabel: 'ai-settings-tab',
    permissions: [PERMISSIONS.CASES_READ, PERMISSIONS.INTERNAL]
  },
  {
    label: 'Integrations',
    path: '/administration/integrations',
    value: 3,
    ariaLabel: 'integrations-tab',
    permissions: [PERMISSIONS.ADMIN_READ]
  },
  {
    label: 'Notifications',
    path: '/administration/notifications',
    value: 4,
    ariaLabel: 'notifications-tab',
    permissions: 'exempt'
  },
  {
    label: 'Downloads',
    path: '/administration/downloads',
    value: 5,
    ariaLabel: 'downloads-tab',
    permissions: PERMISSIONS.DOWNLOADS_READ
  },
  {
    label: 'Templates',
    path: '/administration/templates',
    value: 6,
    ariaLabel: 'templates-tab',
    permissions: [
      PERMISSIONS.ADMIN_READ,
      PERMISSIONS.INTERNAL,
      PERMISSIONS.TICKETS_UPDATE
    ]
  },
  {
    label: 'Products',
    path: '/administration/products',
    value: 7,
    ariaLabel: 'products-tab',
    permissions: [PERMISSIONS.ADMIN_READ]
  },
  {
    label: 'Network',
    path: '/administration/environments',
    value: 8,
    ariaLabel: 'environments-tab',
    permissions: 'exempt'
  },
  {
    label: 'Pcaps',
    path: '/administration/pcaps',
    value: 9,
    ariaLabel: 'pcaps-tab',
    permissions: PERMISSIONS.PCAPS_READ
  },
  {
    label: 'Suricata',
    path: '/administration/rules',
    value: 10,
    ariaLabel: 'rules-tab',
    permissions: [PERMISSIONS.INTERNAL, PERMISSIONS.SENSOR_RULES_READ]
  }
];

export const DEFAULT_SETTINGS = {
  ai_enable_submission: true,
  auto_close_enabled: true,
  auto_close_period_days: 7,
  contact_email: '',
  contact_name: '',
  contact_phone_number: '',
  display_host_isolation: false,
  email_template_id: 1,
  enable_ticket_assignee: false,
  environments: undefined,
  multifactor: false,
  opsgenie_key: '',
  session_timeout: 15,
  shield_integration: undefined,
  tags: [],
  timezone: '',
  use_modern_email_template: true,
  use_plaintext: false,
  webhook_data_type: '',
  webhook_secret: '',
  webhook_url: '',
  webhook_events: ['create'], // Default to only create events
  weekly_updates: false,
  host_isolation_exclusions: {
    excluded_host_names: [],
    excluded_asset_types: [],
    excluded_asset_subtypes: [],
    excluded_asset_tags: []
  }
};

export default ADMINISTRATION_TABS;
